import { SPI, FormFieldWidget, ViewType, ModelFieldType, FormDateTimeFieldWidget, Widget } from '@kunlun/dependencies';
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: ModelFieldType.DateTime,
    model: 'deli.aries.seller.DeliAriesSellerChangeBill',
    name: 'repaymentDate'
  })
)
export class MyFormDateTimeFieldWidget extends FormDateTimeFieldWidget {
  public initialize(props) {
    super.initialize(props);
    return this;
  }
  @Widget.Watch('formData.repaymentDate', { deep: true, immediate: true })
  watchFormData(val: any) {
    if (!val) {
      this.change(val);
    }
  }
}
